var Backbone, SupportGeneralPopupTemplate, SupportRedemptionInstructionsPopupView,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

SupportGeneralPopupTemplate = require('../../../general_popup.html.mustache');

Backbone = require('backbone');

Backbone.$ = $;

SupportRedemptionInstructionsPopupView = (function(superClass) {
  extend(SupportRedemptionInstructionsPopupView, superClass);

  function SupportRedemptionInstructionsPopupView() {
    return SupportRedemptionInstructionsPopupView.__super__.constructor.apply(this, arguments);
  }

  SupportRedemptionInstructionsPopupView.prototype.initialize = function() {
    _.bindAll.apply(_, [this].concat(_.functions(this)));
    this.I18nScope = 'modules.support';
    this.template = SupportGeneralPopupTemplate;
    return this.order = Groupon.Support.currentOrder;
  };

  SupportRedemptionInstructionsPopupView.prototype.render = function() {
    this.popup = $('#popup');
    GIG.Modal.open({
      el: this.popup,
      closeOnBgClick: true,
      closeOnEscKey: true
    });
    this.$el.html(toHtml(this.template, this.toHash(), this.I18nScope));
    this.popup.html(this.el);
    return openLinksInNewTab($('#popupContent a'));
  };

  SupportRedemptionInstructionsPopupView.prototype.toHash = function() {
    var obj;
    return obj = {
      title: I18n.t("js.modules.support.redemption_instructions"),
      instructions: replaceNewLineWithBreak(this.order.dealOption.instructions)
    };
  };

  SupportRedemptionInstructionsPopupView.prototype.closeModal = function() {
    GIG.Modal.close();
    return false;
  };

  SupportRedemptionInstructionsPopupView.prototype.events = {
    'click .close-modal': "closeModal"
  };

  return SupportRedemptionInstructionsPopupView;

})(Backbone.View);

module.exports = SupportRedemptionInstructionsPopupView;

//# sourceMappingURL=data:application/json;base64,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
